import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-183" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-184" data-mp="2bfzls727p3ze">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl" data-id="element-185" data-mp="2bfg48rgh4hlw">
          ¿Te pasa alguno de estos?
        </h2>

        <ul className="mx-auto mt-12 grid max-w-4xl gap-3 md:grid-cols-2 md:gap-4" data-id="element-186" data-mp="21od2dnfpzylk">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 rounded-xl bg-red-50 px-5 py-4 ring-1 ring-red-100" data-id="element-187" data-mp="26ipok58kzo10">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-188" data-mp="1wruz6s01g8bc">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-189" data-mp="1irtz3erll4wx" />
              </span>
              <span className="font-medium leading-snug text-gray-900" data-id="element-190" data-mp="1nplrsb02gv26">{point}</span>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-191" data-mp="tbrq6sk7keam">
          <p className="text-xl font-bold leading-snug tracking-tight text-gray-900 md:text-2xl" data-id="element-192" data-mp="oa2edap5vwlh">
            No necesitas memorizar 150 nombres aislados.
          </p>
          <p className="mt-2 text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-193" data-mp="xb0kpzn2og78">
            Necesitas saber qué detalle mirar para reconocer cada instrumento.
          </p>
        </div>
      </div>
    </section>;
}